import { CheckmarkCircle01Icon, CancelCircleIcon, ViewIcon } from "@hugeicons/core-free-icons"
import { HugeiconsIcon } from "@hugeicons/react"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

interface ApprovalBannerProps {
  onApprove: () => void
  onReject: () => void
  onViewOnCanvas: () => void
  isApproving?: boolean
  isRejecting?: boolean
  className?: string
}

export function ApprovalBanner({
  onApprove,
  onReject,
  onViewOnCanvas,
  isApproving,
  isRejecting,
  className,
}: ApprovalBannerProps) {
  return (
    <div
      className={cn(
        "flex items-center gap-3 rounded-xl border border-orange-500/30 bg-orange-500/10 px-4 py-2.5",
        className,
      )}
    >
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <span className="inline-flex size-2 flex-shrink-0 animate-pulse rounded-full bg-orange-400" />
        <span className="truncate text-sm font-medium text-orange-700 dark:text-orange-300">
          Pipeline paused — your review is required
        </span>
      </div>

      <div className="flex flex-shrink-0 items-center gap-2">
        <Button
          size="sm"
          variant="ghost"
          className="h-7 gap-1.5 px-2.5 text-xs text-muted-foreground hover:text-foreground"
          onClick={onViewOnCanvas}
        >
          <HugeiconsIcon icon={ViewIcon} size={13} />
          View on canvas
        </Button>

        <Button
          size="sm"
          variant="outline"
          className="h-7 gap-1.5 border-red-500/40 px-2.5 text-xs text-red-600 hover:bg-red-500/10 hover:text-red-600 dark:text-red-400"
          onClick={onReject}
          disabled={isApproving || isRejecting}
        >
          <HugeiconsIcon icon={CancelCircleIcon} size={13} />
          {isRejecting ? "Rejecting…" : "Reject"}
        </Button>

        <Button
          size="sm"
          className="h-7 gap-1.5 bg-green-600 px-2.5 text-xs text-white hover:bg-green-700"
          onClick={onApprove}
          disabled={isApproving || isRejecting}
        >
          <HugeiconsIcon icon={CheckmarkCircle01Icon} size={13} />
          {isApproving ? "Approving…" : "Approve"}
        </Button>
      </div>
    </div>
  )
}
